export default {
    txt_welcome: 'Bienvenido',
    txt_dataover: 'Visión general',
    txt_chance: 'Oportunidad de ventas',
    txt_device: 'Dispositivo',
    txt_chinese: 'Chino-Chino',
    txt_english: 'English',
    txt_malay:'Malaysia',
    txt_german:'Deutsch',
    txt_french:'Francais',
    txt_italian:'Italiano',
    txt_spanish:'Español',
    txt_reports: 'Historico de inspecciones',
    txt_setting: 'Configuraciones ',
    txt_dymanager: 'Empleados',
    txt_account: 'ID: Cuenta',
    txt_userstatus: 'Identidad del usuario',
    txt_name: 'Nombre',
    txt_contactway: 'Información de contacto',
    txt_accountsafe: 'Seguridad de la cuenta',
    txt_basicinfo: 'Información básica',
    txt_updatepassword: 'Modificar contraseña',
    txt_storeinfomation: 'Información de la tienda',
    txt_storename: 'Nombre de la tienda',
    txt_storephone: 'Número de teléfono de la tienda',
    txt_storeaddress: 'Dirección de la tienda',
    txt_AppInfomation: 'Información de la aplicación ',
    txt_currentversion: 'Versión actual.',
    txt_software: 'Actualización de software',
    txt_loginout: 'Salir de inicio de sesión',
    txt_updatelanguage: 'Idioma',
    txt_updateto: 'Actualizar a',
    txt_zwgx: 'Ninguna actualización',
    txt_dz: 'Gerente de tienda',
    txt_sh: 'Comerciante',
    txt_dy: 'Empleado',
    txt_bdsj: 'Enlazar teléfono móvil',
    txt_shxx: 'Información del comerciante',
    txt_shname: 'Nombre del comerciante',
    txt_ssmd: 'Tienda propia',
    txt_bdsb: 'Vincular dispositivo',
    txt_mendian: 'Tienda',


    //数据总览模块
    txt_sTime: 'Seleccione período',
    txt_car_check: 'Tasa de inspección del vehículo',
    txt_findchance: 'Oportunidades de ventas',
    txt_trackchace: 'Tasa de seguimiento',
    txt_transform: 'Tasa de conversión',
    txt_TotalData: 'Visión general',
    txt_xxsj: 'Datos detallados',
    txt_zhsj: 'Conversión de datos',
    txt_TireWear: 'Desgaste del neumático',
    txt_DataHopper: 'Cuello de botella',
    txt_jdcc: 'Tráfico de vehículos',
    txt_CheckCar: 'Número de vehículos escaneados',
    txt_ChanceNum: 'Cantidad de oportinidades de ventas',
    txt_TrackNum: 'Número de rastreo',
    txt_TranseformNum: 'Conversiones',
    txt_UnTrack: 'Sin Seguimiento',
    txt_l: 'Vehículos',
    txt_Time: 'Tiempo',
    txt_Device: 'Dispositivo',
    txt_car_plate: 'Placa de matrícula',
    txt_Wear: 'Desgaste',
    txt_Pwear: 'Desgaste desigual',
    txt_NoData: 'Sin datos',
    txt_GoodState: 'Normal',
    txt_Border: 'Estado límite',
    txt_replace: 'Reemplazar ahora',
    txt_Total_Check: 'Total vehículos inspeccionados',
    txt_pmqk: 'Desgaste Desigual',
    txt_LightWear: 'Desgaste desigual lígero',
    txt_GraveWear: 'Desgaste desigual grave',
    txt_hwtj: 'Número de rataciones',
    txt_wxhw: 'No necesita rotación',
    txt_xyhw: 'Necesita rotación',
    txt_jcxq: 'Detalles de inspecciones',
    txt_zhxq: 'Detalles de conversión',
    txt_cc: 'Vehículos',
    txt_bfb: 'Porcentaje',
    txt_ltxs: 'Venta de neumáticos.',
    txt_sldw: 'Alineación de ruedas',
    txt_ddlph: 'Balance Dinámico',
    txt_dphhh: 'Balance Dinámico',
    txt_qt: 'Otros',
    txt_zhqs: 'Tendencia de conversión',
    txt_ltxl: 'Venta de neumáticos.',
    txt_ltfw: 'Servicio de neumáticos',
    txt_ckxq: 'Comprobar detalles',
    txt_jt: 'Hoy',
    txt_zt: 'Ayer',
    txt_bz: 'Esta semana',
    txt_by: 'Este mes',
    txt_sy: 'El mes pasado',
    txt_jn: 'Este año.',
    txt_zhcl: 'Cantidad de conversión (vehículos)',
    txt_zhl: 'Tasa de conversión',
    txt_bfb: 'Porcentaje',
    txt_abjx: 'Distribución de neumáticos en estado límite',
    txt_aljg: 'Distribución de neumáticos para reemplazar inmediatamente',
    txt_qwpm: 'Distribución de neumáticos bajo lígero desgaste desigual',
    txt_ayzp: 'Distribución de neumáticos bajo grave desgaste parcial',
    txt_lingt: '0 Neumáticos',
    txt_yt: '1 Neumático',
    txt_et: '2 Neumáticos',
    txt_st: '3 Neumáticos',
    txt_ft: '4 Neumáticos',

    //机会
    txt_xsjh: 'Oportunidades de ventas',
    txt_gzz: 'Rastreo', 
    txt_clwb: 'Procesado',
    txt_ckbg: 'Ver informe',
    txt_yxs: 'Todos los datos mostrados',
    txt_zhuiz: 'Pista',
    txt_tix: 'Recordar',
    txt_chuli: 'Tratar con',
    txt_yzh: 'Convertido',
    txt_wzh: 'No convertido',
    txt_gzsmts: '{0} Verifique si hay algún problema, se estima que {1} vendrá a la tienda para su reparación.',
    txt_czbty: 'En desacuerdo',
    txt_yyx: 'Tener la intención',
    txt_ltyg: '1 Neumático',
    txt_ltkg: '2 Neumáticos',
    txt_ltsang: '3 Neumáticos',
    txt_ltsig: '4 Neumáticos',
    txt_jhcl: 'Tratamiento de oportunidad',
    txt_jhztai: 'Estado de oportunidad',
    txt_crquy: 'Área de responsabilidad',
    txt_chuliry: 'Personal de procesamiento',
    txt_chulijg: 'Resultado del proceso',
    txt_zhuanhuanr: 'Contenido de conversión',    
    txt_zhuanhuaje: 'Ingresos',
    txt_zhuanhuasj: 'Tiempo',
    txt_zhuanhuayx: 'Intención',
    txt_xuanzesj: 'Seleccione hora',
    txt_tsdatawk: 'Las oportunidades de ventas está vacío, los datos no se pueden guardar',
    txt_qtxzhsj: 'Introduzca el tiempo estimado de intención de conversión',
    txt_qtxzhnr: 'Complete el contenido de conversión',
    txt_qtxzhsj: 'Por favor complete el tiempo de conversión',
    txt_sbts: 'El guardado de información ha fallado, por favor compruebe la conexión a la red',


    //设备
    txt_sbgl: 'Gestión de dispositivos',
    txt_tj: 'Agregar',
    txt_gdssb: 'Total de dispositivos{0}',
    txt_sbbh: 'ID del dispositivo',
    txt_gjbb: 'Versión de software',
    txt_tjsj: 'Agregar hora',
    txt_zdgx: 'Actualización automática',
    txt_gxgj: 'Actualización de software',
    txt_jieb: 'Desenlazar',
    txt_sbtsxx: 'El dispositivo tiene actualizaciones, por favor haga clic para actualizar',
    txt_wjh: 'Desactivada',
    txt_lix: 'Fuera de línea',
    txt_zaix: 'En línea.',
    txt_guz: 'Falló',
    txt_yijieb: 'Sin vincular',
    txt_yihuis: 'Regenerado',
    txt_gxsbgj: 'Dispositivo de actualización',
    txt_gxsbgjts: 'Desea actualizar el dispositivo?',
    txt_socketdk: 'La comunicación con el servidor no está establecida, intente nuevamente',
    txt_cscgts: 'Solicitud de actualización enviada con éxito',
    txt_jbsb: 'Desenlazar dispositivo',
    txt_jbsbts: '¿Estás seguro de que deseas desvincular el dispositivo?',
    txt_tscg: 'Operación exitosa',
    txt_zdgxgj: 'Actualizar firmware automáticamente',
    txt_gxgjts: '¿Está seguro de que desea la función de actualización automática de firmware para el dispositivo {0}?',
    txt_beiz: 'Observacione',
    txt_qtxbz: 'Por favor complete los comentarios',
    txt_bdsbts: 'Esta aplicación se utiliza para la profundidad de banda de rodadura de neumáticos detector inteligente, por favor asegúrese de que el dispositivo es correcto. ',
    txt_qdksb: 'Por favor, encienda el dispositivo',
    txt_dksbts1: '1. El proceso de vinculación del dispositivo, se iniciará después de reiniciar el dispositivo.',
    txt_dksbts2: '2. Si el dispositivo se ha vinculado a otras tiendas antes, haga clic en desvincular dispositivo en el menú "Configuración" del dispositivo. Después de desemparejar, el dispositivo iniciará automáticamente el proceso de vinculación',
    txt_yjdksblw: 'Dispositivo encendido y conectado a internet',
    txt_xyb: 'Siguiente paso',
    txt_qsclj: 'Por favor, escanear el código QR con el dispositivo',
    txt_qscts1: 'Por favor, utilice el dispositivo para escanear el código QR, si la operación de escaneo se ha realizado correctamente, el dispositivo emite un pitido.',
    txt_qscts2: 'Escaneé el código correctamente',
    txt_sbtssmcg: 'El dispositivo ha escaneado el código con éxito',
    txt_ddsblw: 'A la espera de la red',
    txt_zznlbd: 'Forzar vinculación del dispositivo',
    txt_qszdd: 'Esto puede llevar 10 segundos, por favor espere',
    txt_bdcg: 'Dispositivo vinculado con éxito',
    txt_tjcg: 'Añadido con éxito',
    txt_tjcgts: 'Enhorabuena, el dispositivo se agregó correctamente. Comente el dispositivo para identificarlo fácilmente',
    txt_fhsblb: 'Regresar a la lista de dispositivos',
    txt_jxtjsb: 'Continuar agregando dispositivo',
    txt_bzmc: 'Observación del dispositivo',


    //检测记录
    txt_sx: 'Filtrar',
    txt_khsj: 'Teléfono móvil del cliente',
    txt_cphm: 'Número de placa de matrícula',
    txt_cphm1: 'Número de placa de matrícula',
    txt_clxh: 'Modelo de vehículo',
    txt_xgbz: 'Editar las notas',
    txt_gtfjl: 'Total informes  {0}',
    txt_jcsj: 'Tiempo de elección',
    txt_jcsj1: 'Tiempo de elección',
    txt_xzkssj: 'Elige la hora de inicio',
    txt_xzjssj: 'Elige la hora de final',
    txt_jcjg: 'Resultados de la prueba',
    txt_msqk: 'Condiciones de desgaste',
    txt_jygh: 'Recomendar reemplazar',
    txt_zysh: 'Preste atención a la perdida',
    txt_zcsy: 'Uso normal',
    txt_zc: 'Normal',
    txt_cz: 'Restablecer',
    txt_qd: 'Seguro',
    txt_jcjgd: 'Resultados de la prueba',
    txt_msqkd: 'Condición de desgaste',
    txt_sldwd: 'Alineación de ruedas',
    txt_jyghd: 'Reemplazo recomendado',
    txt_zysh: 'Preste atención a la perdida',
    txt_zcsyd: 'Uso normal',
    txt_xdwd: 'Es necesario alineación',
    txt_xzyd: 'Necesaria atención',
    txt_zcd: 'Normal',
    txt_bgxq: 'Detalles del informe',
    txt_ljdy: 'Conectado con impresión',
    txt_fwmd: 'Servicio de tienda',
    txt_mddz: 'Direciión de la tienda',
    txt_jcsb: 'Equipo de detección',
    txt_ddmd: 'Dirijasé a la tienda',
    txt_lic: 'Kilometraje',
    txt_chex: 'Modelo del vehículo',
    txt_jcjyi: 'Recomendaciones de inspección',
    txt_ysbs: 'Descripción del Color',
    txt_ztms: 'Desgaste general',
    txt_hwms: 'Desgaste desigual',
    txt_dqscjltx: 'Recordatorio actual de distancia de frenado',
    txt_bgxqts: 'Observaciones: La prueba la lleva a cabo el centro de pruebas independiente Tianjin Automobile Inspection Center. El vehículo utilizado es un turismo de la marca Audi FV7203BECGB. La especificación del neumático es: 245/40 R18. La presión de inflado de los neumáticos es: neumático delantero 230kpa y neumático trasero 220kpa; el sitio de prueba es: el sitio de prueba de Cadaque Yancheng; el rango de velocidad calculado a partir de la distancia de frenado del vehículo',
    txt_wxsmgz: 'Siga la cuenta oficial de Tyhrhub de Wechat',
    txt_hwmsjh: 'Desgaste uniforme ',
    txt_zqlun: 'Neumático DI',
    txt_zhlun: 'Neumático TI',
    txt_yqlun: 'Neumático DD',
    txt_yhlun: 'Neumático TD',
    txt_pingjunzhi: 'Promedio de valor',
    txt_guige: 'Tamaño',
    txt_gongli: 'Kilometraje',
    txt_ltwjc: 'Sin inspeccionar ',
    txt_pinpai: 'Marca',
    txt_ltws: 'Apariencia del neumático',
    txt_sewmts: 'Escanear código QR para comprobar informe',
    txt_print: 'Print',





    //店员管理
    txt_xz: 'Agregar',
    txt_qy: 'Habilitar',
    txt_qyz: 'Activo',
    txt_ty: 'Deshabilitar',
    txt_yhzh: 'Cuenta de usuario',
    txt_lxfs: 'Información de contacto',
    txt_cjsj: 'Tiempo de creación',
    txt_bjxx: 'Editar información',
    txt_xgmm: 'Modificar contraseña',
    txt_bgzt: 'Cambio de estado',
    txt_qdytjm: 'Está seguro que desea deshabilitar la cuenta{0}{1}?',
    txt_tjdy: 'Agregar empleado',
    txt_bjdyxx: 'Editar información del empleado',
    txt_zhxx: 'Información de la cuenta',
    txt_ygxm: 'Nombre del empleado',
    txt_qtxygxm: 'Por favor, introduzca el nombre del empleado',
    txt_lxdh: 'Información de contacto',
    txt_qtxyglxdh: 'Número de teléfono',
    txt_dxyzm: 'Código de verificación por SMS',
    txt_qtxdxyzm: 'Por favor introduzca el código de verificación',
    txt_fsdx: 'Enviar SMS',
    txt_tjzh: 'Agregar cuenta',
    txt_baocun: 'Guardar',
    txt_gtgygzh: 'Total de {0} cuentas de empleado',



    //登录
    txt_qdytcdlm: 'Está seguro que desea desconectarse?',
    txt_qx: 'Cancelar',
    txt_dl: 'Iniciar sesión',
    txt_qsrzh: 'Por favor ingrese ID de la cuenta (para número de cuenta del comerciante ingrese número de teléfono móvil registrado)',
    txt_qsrmm: 'Por favor introduzca su contraseña',
    txt_zcshzh: 'Registrar una cuenta de comerciante',
    txt_shzhwjmm: 'Olvidó la contraseña de la cuenta de comerciante',
    txt_yzdqmm: 'Verificar contraseña actual',
    txt_szxmm: 'Establecer nueva contraseña',
    txt_xgcg: 'Modificación exitosa',
    txt_qtxjmm: 'Por favor ingrese la contraseña antigua',
    txt_yzzcsj: 'Verifique el teléfono móvil registrado',
    txt_qtxxmm: 'Introduzca nueva contraseña',
    txt_qzctxxmm: 'Repetir la nueva contraseña',
    txt_lcmmsrbyz: 'Las dos contraseñas son diferentes',
    txt_gxnxgcg: 'Felicitaciones, la contraseña se modificó con éxito',
    txt_qljndxmm: 'Por favor recuerde su nueva contraseña',
    txt_fhgrzx: 'Regrese al espacio personal',
    txt_fsyzm: 'Enviar código de seguridad.',
    txt_qtxzcsjh: 'Por favor, introduzca su teléfono móvil registrado',
    txt_qtxtxyzm: 'Por favor, introduzca el código de verificación gráfico',
    txt_qsryzm: 'Por favor ingrese el código de verificación',
    txt_qszhhmm: 'Establezca una nueva contraseña que conste de 6-18 dígitos y letras',
    txt_qzcsrmm: 'Por favor ingrese la contraseña nuevamente.',
    txt_lcmmbyz: 'Las dos contraseñas son deiferentes',
    txt_hdsy: 'Regrese a la página principal',
    txt_zcshh: 'Número de comerciante registrado',
    txt_fhdl: 'Regrese a la página de inicio de sesión',
    txt_wlqqsb: 'Falló de red, por favor vuelva a intentarlo',
    txt_wczc: 'Registro completado',
    txt_wsts: 'Antes de comenzar, complete la información de su negocio',
    txt_qtxshmc: 'Por favor ingrese el nombre del comerciante',
    txt_shmc: 'Nombre del comerciante',
    txt_rgszjd: 'Como el número de teléfono de la empresa, fax, etc.',
    txt_qtlxfs: 'Otra información de contacto',
    txt_kssy: 'Comience a usar',
    txt_Pwear1: 'Desgaste desigual',
    txt_open: 'Abierto',
    txt_close: 'Cerca',
    txt_srczhdmm: 'Introduzca la nueva contraseña',
    txt_kcfs: 'Reenviar después de {0}s',
    txt_xiugai: 'Modificar',
    txt_zzjzsj: 'Cargando',
    txt_bjshxx: 'Editar información del comerciante',
    txt_chongxinhq: 'Reenviar',
    txt_gaibangsj: 'Cambiar el teléfono móvil',
    txt_yanzhengjsj: 'Verificar el teléfono móvil antiguo',
    txt_bangdingxsj: 'Vincular el nuevo teléfono móvil',
    txt_yhqsyxsjdl: 'Por favor, inicie sesión con un nuevo teléfono móvil',



    //登录新
    txt_xzshenfen: 'Por favor seleccione su rol',
    txt_dlrolewz: 'Iniciar sesión {0}',
    txt_qsrsjh: 'Introduzca el número de teléfono',
    txt_zhuce: 'Registrar',  
    txt_wanjimima: 'Olvido su contraseña',
    txt_wanshandzxx: 'Por favor complete la información',
    txt_qsrxm: 'Por favor, introduzca el nombre',
    txt_qsrmdm: 'Por favor, introduzca el nombre de la tienda',
    txt_qsrmdgddh: 'Por favor, introduzca el teléfono fijo de la tienda',
    txt_qsrmddz: 'Por favor, introduzaca la dirección del establecimiento',
    txt_qsrgsdz: 'Por favor, introduzca la dirección de la empresa',
    txt_qsrxxdz: 'Por favor, introduzca la dirección detallada',
    txt_tijiaocg: 'Enviado exitosamente',
    txt_qsvbsylwmm: 'Por favor introduzca una contraseña de más de 6 dñigitos',
    txt_zhucerole: 'Número de registro {0}',
    txt_qsrshh: 'Por favor, ingrese la cuenta del comerciante',
    txt_qsrdzh: 'Por favor, introduzca la cuenta del administrador',
    txt_wsshhzl: 'Por favor, complete la información del comerciante',
    txt_wsdyhzl: 'Por favor, complete la información de los empleados',
    txt_qsrshm: 'Por favor introduzca el nombre comercial',
    txt_qsrshz: 'Por favor, introduzca el nombre del encargado del negocio',
    txt_qsrzrqy: 'Por favor, introduzca el area de responsabilidad (area de trabajo)',
    txt_shanghudizhi: 'Dirección comercial',
    txt_yhycz: 'Cuenta o número de teléfono existe',
    txt_qsrzqdzh: 'Por favor, ingrese la cuenta de comerciante correcta',
    txt_qsrzqshh: 'Seleccione consulta de la tienda',
    txt_xzmdcx: 'Seleccione la tienda',



    //门店
    txt_mendianId: 'Identificación de la tienda',
    txt_mendianmc: 'Nombre de la tienda',
    txt_mendiandz: 'Dirección de la tienda',
    txt_mendiandh: 'Número de teléfono de tienda',
    txt_caozuo: 'Funcionar',
    txt_mendiangl: 'Gestión de la tienda',
    txt_gjmendian: 'Total tiendas {0}',
    txt_zhengchangyy: 'Negocio normal',
    txt_tingye: 'Cerrado',
    txt_gengdxx: 'Más información',
    txt_dianygl: 'Gestión de empleados',
    txt_biangzt: 'Cambio de estado',
    txt_qdygbzhuangtai: '¿Está seguro que desea cambiar el estado de la tienda de {0} a {1}?',
    txt_bjmendian: 'Editar información de la tienda',
    txt_xinzenmd: 'Tienda nueva',
    txt_qtxmdmc: 'Por favor, ingrese el nombre de la tienda',
    txt_qxzmddz: 'Por favor, seleccione la dirección de la tienda',
    txt_qtxxdz: 'Por favor, ingrese la dirección detallada',
    txt_xiangxidz: 'Dirección',
    txt_qtxmddh: 'Por favor, ingrese el teléfono de la tienda',
    txt_dzxx: 'Información del gerente',
    txt_chaungjianmendian: 'Crear tienda',
    txt_mendianxxxx: 'Detalles de la tienda',
    txt_bianji: 'Editar',
    txt_mendianzt: 'Estado de la tienda',

    //商户数据总览
    txt_mendianshuju: 'Almacenamientos de datos',
    txt_chakangdxxbb: 'Vea informes detallados',
    txt_jczcs: 'Número total de inspecciones',
    txt_mdpjjc: 'Promedio de inspecciones de la tienda',
    txt_jdzcl: 'Flujo total de vehículos de la tienda',
    txt_jcl: 'Tasa de inspección',
    txt_msqkjgtj: 'Estadísticas de estado de desgaste (número de neumáticos)',
    txt_xyghltjgfb: 'La distribución de los resultados que necesitan ser reemplazados',
    txt_xzzyltjgfb: 'Preste atención a la distribución de resultados de los neumáticos',
    txt_sldwjgtj: 'Estadísticas de resultados de alineación de cuatro ruedas (número de neumáticos)',
    txt_xjxsldwfb: 'Distribución de resultados de los neumáticos de alineación en las cuatro ruedas',
    txt_xzzyjxsldwfb: 'Preste atención a la distribución de los resultados de la preparación de neumáticos de alineación en las cuatro ruedas.',
    txt_jrzl: 'Vista general actual',
    txt_xiangqbb: 'Informe detallado',
    txt_xuanzerqckxxsj: 'Seleccione fecha para visualización de información detallada',
    txt_qxzsjd: 'Por favor seleccione periodo',
    txt_sjdts: 'Sólo puede seleccionar un período inferior a 30 días',
    txt_zonglan: 'Visión general',
    txt_qushi: 'Tendencia',
    txt_shuliangtj: 'Total',
    txt_syjcjgz: '所有检测结果中，各种磨损情况的轮胎条数及占比',
    txt_mslttsfb: '磨损轮胎条数分布情况',
    txt_msbgslzb: '(不同条数轮胎磨损的报告数量、以及在总检测数中的占比）',
    txt_sldwjlzb: '所有检测结果中，各种四轮定位结论的轮胎条数及占比',
    txt_sldwfbqk: '四轮定位结论条数分布情况',
    txt_btjgsldwzb: '不同条数四轮定位结论的报告数量、以及在总检测数中的占比',
    txt_jccsqs: "Tendencia de la cantidad de inspecciones",
    txt_msqkslqs: 'Tendencia de desgaste de neumáticos',
    txt_jgfbqushi: '磨损轮胎需更换轮胎的结果分布趋势',
    txt_msltjgfbqs: '磨损轮胎需注意轮胎的结果分布趋势',
    txt_ltxsldwslqs: '轮胎需四轮定位情况数量趋势',
    txt_jccs: "Cantidad de vehículos inspeccionados",
    txt_shuliang: "Cantidad",
    txt_zhanbi: '%',
    txt_chankangd: 'Ver más',
    txt_chakanmdxxbb: 'Ver los detalles de los informes de la tienda',


    //国家
    txt_zhongguo: 'China',
    txt_mlxy: 'Malysia',
    txt_yindu: 'India',
    txt_taiguo: 'Tailandia',
    txt_oluosi: 'Rusia',



    txt_taici: 'Vehículos',
    txt_jianyi: 'Sugerencia:',
    txt_jianyineirong: 'El neumático tiene desgaste anormal, rotación del neumático, por favor verifique nuevamente.',
    txt_jianyineirongzc: 'Normal',
    txt_bgtixing: 'Recordatorio:',
    txt_bgtuxubfnr: 'Según el desgaste de los neumáticos, la distancia de frenado se incrementa en un {0}% (estimado)',
    txt_waishang: 'Daño',
    txt_laohua: 'Envejecimiento',
    txt_gubao: 'Bulto',
    txt_xichemeirong: 'Lavado de vehículos y detalle',
    txt_weixiubaoyang: 'Mantenimiento',
    txt_guenghuanluntai: 'Reemplazo de neumáticos',
    txt_scsltjcy: 'Escaner portátil de neumáticos',
    txt_shijiantishi: 'La hora de inicio debe ser anterior a la de finalización',
    txt_qxzclry: 'Por favor seleccione el controlador',
   
    txt_lf_outworn: 'El exterior del neumático delantero izquierdo está más desgastado que el interior.',
    txt_lf_innerworn: 'El interior del neumático delantero izquierdo está más desgastado que el exterior',
    txt_lf_bothsideworn: 'Ambos lados del neumático delantero izquierdo están más desgastados que el centro',
    txt_lf_centreworn: 'El centro del neumático delantero izquierdo está más desgastado que ambos lados',
    txt_lb_outworn: 'El exterior del neumático trasero izquierdo está más desgastado que el interior',       
    txt_lb_innerworn: 'El interior del neumático trasero izquierdo está  más desgastado que el exterior.',        
    txt_lb_bothsideworn: 'Ambos lados del neumático trasero izquierdo están más desgastados que el centro',        
    txt_lb_centreworn: 'El centro del neumático trasero izquierdo está más desgastado en ambos lados',        
    txt_rb_outworn: 'El exterior de la parte trasera derecha está más desgastado que el interior.',         
    txt_rb_innerworn: 'El interior de la parte trasera derecha está más desgastado que el exterior.',        
    txt_rb_bothsideworn: 'Ambos lados de la parte trasera derecha están más desgastados que el centro.',         
    txt_rb_centreworn: 'El centro de la parte trasera derecha está más  desgastado en ambos lados.',        
    txt_rf_outworn: 'El exterior del neumático delantero derecho está más  desgastado que el interior',         
    txt_rf_innerworn: 'El interior del neumático delantero derecho está más desgastado que el exterior.',        
    txt_rf_bothsideworn: 'Ambos lados del neumático delantero derecho están  más desgastados que el centro.',       
    txt_rf_centreworn: 'El centro del neumático delantero derecho está más desgastado en ambos lados',         
    txt_tire_need_replace: 'Hay neumáticos que necesitan ser reemplazados inmediatamente',         
    txt_tire_boundary: 'Estado de desgaste de los neumáticos: límite',  
    'txt_tire_boundary;': 'Estado de desgaste de los neumáticos: límite',        
    txt_alignment_chassis: 'Se recomienda la alineación y la verificación del chasis',   
    txt_wear_uniform: 'El desgaste de los neumáticos es uniforme.',   
    'txt_wear_uniform;': 'El desgaste de los neumáticos es uniforme.',                
    txt_do_further_check: 'Por favor, verifique nuevamente',                    
    txt_uneven_check: 'El neumático tiene un desgaste anormal, se recomienda una nueva verificación',     
    'txt_uneven_check;': 'El neumático tiene un desgaste anormal, se recomienda una nueva verificación',     
    txt_tire_rotation: 'Se recomienda rotación del neumático',           
    txt_wear_normal: 'Desgaste del neumático es normal',    
    'txt_wear_normal;': 'Desgaste del neumático es normal',                 
    txt_tire: 'Neumático',
    txt_xiazai:'Descargar',
    txt_xiazaishibai:'Falló de la descarga',
    txt_fanhui: 'Atrás  ',
    txt_yszc:'Política de privacidad',
    txt_djtyjbsydty:'Haga clic en aceptar para indicar que ha leído y está de acuerdo',
    txt_djyszc:'《Política de privacidad》',
    txt_tongyi:'Acordado',
    txt_btongyi:'En desacuerdo',
    txt_yszcnr:'Haga clic en aceptar para indicar que ha leído y está de acuerdo [preste atención] si no está de acuerdo con el acuerdo anterior o cualquiera de sus términos, por favor desregistrase. No podrá disfrutar de nuestros servicios después de dejar de registrarse. Si usted completa la información de acuerdo con el proceso de registro, lee y hace clic en aceptar el acuerdo anterior y completa el proceso de registro, usted ha leído, entendido y aceptado por completo todo el contenido del acuerdo',
    txt_qsrszcs:'Introduzca su ciudad',
    txt_qsrszsf:'Por favor, rellene su ubicación',
    txt_qwsxx:'Por favor complete sus datos',
    txt_shujufx:'数据分享',
    txt_fenxiang:'分享',
    txt_djxybbs:'点击下一步表示你已阅读并同意',
    txt_yhxy:'《用户协议》',
    txt_xxfxsz:'Configuraciones',
    txt_jsfzh:'接收方账号',
    txt_xzfxxx:'选择分享信息',
    txt_jianceliang:'检测量',
    txt_fenxiangjieshu:'分享结束时间',
    txt_jieshou:'接收',
    txt_jujue:'拒绝',
    txt_jieshoufenxiang:'接受分享',
    txt_jieshoushanghu:'接收商户:',
    txt_zhongzhi:'终止',
    txt_fenxiangzhong:'分享中',
    txt_fenxiangshanghu:'分享商户',
    txt_jieshouzhong:'接收中',
    txt_sousuo:'搜索',
    txt_jiance:'检测',
 
    txt_fenxiangtishi:'对方没有分享此数据给您，无权查看',




     //报告新增 
     'txt_tire_age_8': 'Los neumáticos están disponibles desde hace más de 8 años y se recomienda una revisión completa de los neumáticos',
     'txt_tire_age_6': 'Los neumáticos están disponibles desde hace más de 6 años y se recomienda una revisión completa de los neumáticos',
     'txt_tire_age_5': 'Los neumáticos se han utilizado durante más de 5 años. Se recomienda revisar los neumáticos minuciosamente y reemplazarlos si es necesario.',
     'txt_tire_age_3': 'Los neumáticos están disponibles desde hace más de 3 años y se recomienda una revisión completa de los neumáticos',
     'txt_tire_age_ok': 'La antigüedad del neumático es buena',
     'txt_tire_age_ok;': 'DOT es correcta',
     'txt_tire_trauma_check': 'El neumático tiene un daño, por favor verifique nuevamente',
     'txt_install_abnormal_check': 'La instalación de los neumático es anormal, por favor confirmar',
     'txt_tire_appearance_ok': 'La apariencia del neumático es OK',
     'trauma_lacerate': 'Laceración',
     'trauma_dropblock': 'Bloque caído',
     'trauma_puncture': 'Pinchazo',
     'trauma_scratch': 'Rasguño',
      'txt_tire_age': 'DOT del neumático',
     'txt_tire_appearance': 'Aspecto de los neumáticos',
      //未翻译
      txt_plcl:'Procesando lote',
      txt_qbxz:'Seleccionar todo',
      txt_scjcjg:'Último informe de inspección',
      txt_ltxhlcgs:'Estimación de kilometraje del neumático',
      txt_ltazhuang:'Montaje neumático:',
      txt_wear_overall:'Desgaste general', 
      txt_pattern_wear:'Desgaste desigual', 
      txt_ltlcgstm:'Sobre la base del estado actual del desgaste del neumático, la distancia de recuperación del neumático es {0} km (evaluación previa)',
 
      txt_yichang:'Neumático anormal',
      txt_qjybjcltazqk:'Por favor, compruebe el montaje del neumático',
      txt_dottx:'Estimación de tiempo de servicio del neumático',
      txt_dottxjy:'Los neumáticos han estado en uso durante más de tres años.',
      txt_danweinian:'(Unidad Año)',
      txt_danweikm:'(Unidad:km)',
      txt_shurujb:"Introducir 'Desenlazar' para desactivar el dispositivo",
      txt_shuruzqwa:'Por favor, introduzca el texto.',
      txt_myhqdsj:'Sin tiempo para obtener el DOT',
      txt_dotjstx:'Tiempo estimado de uso del neumático es {0} días.',
      txt_dotjstx2:'El neumático ha sido usado por más de 5 años, por favor reemplacelo',
      txt_dotsjztx:'(DOT Fecha de fabricación de neumáticos)',
      txt_gelie:'Laceración',
      txt_diaokuai:'Bloque caído',
      txt_chaungci:'Pinchazo',
      txt_cashang:'Rasguño',
      txt_yichang:'Neumático anormal',
      'txt_tire_need_replace;': 'Hay neumáticos que deben cambiarse de inmediato', 
           //未翻译
    txt_jishimz:'Técnico',
    txt_ltlcgsnew:'El neumático tiene una estimación de {0}km',
    txt_ltlcgsnewin: 'Tire range is {0} miles',
    txt_pinnate_check:'Los neumáticos tienen un desgaste de plumas, por favor comprueben más', 
    txt_pinnate_wear: 'Desgaste en pluma',
    txt_msjxtx:'El neumático ha alcanzado su límite, por favor reemplacelo.',
    txt_ltfz:'Interior y exterior',
    txt_install_check: 'Inspección de instalación',
    txt_install_ok:'Instalación normal',
    LF:'[Neumático DI]',
    RF:'[Neumático DD]',
    LB:'[Neumático TI]',
    RB:'[Neumático TD]',
    FF:'[Eje delantero]',
    BB:'[Eje trasero]',
    txt_appearance_check:'Hay un daño en el neumático, confirme la reparación.',
    txt_uneven_center:'Desgaste del neumático anormal, es recomendable de verificar la presión de inflado',
    txt_uneven_out:'Desgaste neumático anormal en la parte exterior, es recomendable la alineación y verificar la presión de inflado.',
    txt_pinnate_check:'Los neumáticos presentan desgaste de plumas, es recomendable hacer una mayor verificación de la suspensión',
    txt_uneven_inside :'Desgaste anormal en el interior del neumático, es recomendable verificar la alineación y la presión de inflado.',
    txt_uneven_bothside:'Desgaste en ambos lados del neumático, es recomendable verificar la alineación y presión de inflado',

    txt_msyzljgh:'Los neumáticos están severamente gastados, por favor reemplacenlos inmediatamente',
    txt_serious_trauma_check:"El neumático está seriamente dañado, se recomienda su reemplazo",
    txt_appearance_lookup:"Por favor comprobar el estado de los neumáticos",
    txt_wear_lookup :"Por favor comprobar el desgaste del neumático",
    txt_dotscsj:'Fecha de fabricación (DOT)',
    txt_whqdscsj:'Sin fecha de fabricación (No DOT)',
    purp_tireservice:'Servicio de neumático',
    purp_vehicle_inspection:'Inspección de vehículo', 
    txt_chassis_check :'Verificación del chasis',
    txt_chassis_ok:'Revisión del chasis OK',
    txt_chassis_oil:'El amortiguador tiene una perdida de aceite, se recomienda su verificación y si es necesario reeemplazarlo',
    txt_chassis_aging :'La goma de la cabeza del eje está envejecida, se recomienda su reemplazo',
    txt_hood:'Capó del motor',
    txt_wash_liquid:'Líquido lavaparabrisas',
    txt_level_control:'Control de nivel',
    txt_haoxiaoxi:'OK',
    txt_vedi_Note:'Por favor, consulte el manual de usuario',
    txt_replace1:"Reemplazo",
    txt_radiator_fluid:'Líquido de radiador de motor',
    txt_engine_oil:'Aceite de motor',
    txt_brake_fluid:'Líquido de frenos',
    txt_quality_control:'Control de calidad',
    txt_multimeter:'Prueba de multimetro',
    txt_subtotal:'CantidadA',
    txt_shock_absorber:'Amortiguador',
    txt_check_loss:'Verificar daños visibles',
    txt_brake_disc:'Disco de freno',
    txt_wear_condition:"Estado de desgaste ",
    txt_brake_pads:'Pastillas de freno',
    txt_change_control:'Control de cambios',
    txt_air_control:'Sistema de aire acondicionado',
    txt_last_reload:'Última recarga',
    txt_lighting:'Luz',
    txt_verification1:'Limpiaparabrisas',
    txt_dynamometer:'Apriete dinamométrico',
    txt_batteria:'Bateria',
    txt_verification:'Operación de verificación',
    txt_levellow:'Normal',
    txt_levelmiddle:'Agenda de trabajo',
    txt_levelhigh:'Reemplazo',
    txt_tyrenumber:'Profundidad de escaneo:',
    txt_cormach_title:'Desgaste y desgaste desigual',
    txt_wearlow:'Desgaste uniforme ',
    txt_wearmiddle:'Desgaste leve',
    txt_wearhigh:'Severo desgaste',
    txt_namtishi:'Rango de profundidad 1/32',
    txt_zhiliangkongzhi:'Control de calidad',
    txt_buchongzhengduan:'Diagnóstico complementario',
    txt_season_summer:'Neumáticos de verano',
    txt_season_winter:'Neumático de invierno',
  
    // 
    txt_trauma_eattyre:'Desgaste desigual serio',
    txt_uneven_eattyre:'Desgaste de los neumáticos, se recomienda equilibrado, alineación y comprobación de la suspensión',
    txt_appearance_eattyre:'Desgaste de los neumáticos, se recomienda equilibrado, alineación y comprobación de la suspensión',
    txt_chassis_eattyre:'Neumático presenta un desgaste desigual, se recomienda alineación y comprobar sistema de suspensión',
    txt_uneven_high_eattyre:'El neumático presenta un grave desgaste, se recomienda su reemplazo, comprobar la alineación y la suspensión',
    txt_appearance_high_eattyre:'El neumátio presenta un desgaste serio, se recomienda su equilibrado, comprobar la posición de los neumáticos y el sistema de suspensión',
    txt_chassis_high_eattyre:'El neumático presenta un desgaste grave, se recomienda comprobar la alineación y el sistema de suspensión',
    txt_chassis_uneven:'El neumático presenta un desgaste anormal, se recomienda comprobar la alineación y el sistema de suspensión',
    txt_pianmoyichang:'Desgaste anormal del neumático',


    txt_khxm:'Nombre del cliente',
    txt_khyx:'E-mail del cliente',
  
    txt_tireplace:'Lugar del neum',
    txt_tire_season:'Neumáticos para toda la temporada',
    txt_tire_other:'Other tire',
    txt_bolt: 'El cerrojo',
    txt_goods_name:'Nombre de la mercancía',
    txt_yes:'Si',
    txt_no:'No',  
}


// WEBPACK FOOTER //
// ./src/i18n/spanish.js